export type SoundScheme = 'default' | 'minimal' | 'retro' | 'none';

export const getEffectiveVolume = (master: number, system: number, isMuted: boolean) => {
  if (isMuted) return 0;
  const normalize = (v: number) => {
    // If value looks like 0..1, keep it; otherwise treat as 0..100 percentage
    if (v <= 1) return Math.max(0, Math.min(1, v));
    return Math.max(0, Math.min(100, v)) / 100;
  };
  const m = normalize(master);
  const s = normalize(system);
  return Math.max(0, Math.min(1, m * s));
};

export async function playSystemSound(scheme: SoundScheme, vol: number, isMuted: boolean) {
  if (isMuted || vol <= 0 || scheme === 'none') return;

  const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  const gain = ctx.createGain();
  gain.gain.value = vol;
  gain.connect(ctx.destination);

  const playTone = (freq: number, durationMs: number, type: OscillatorType = 'sine') =>
    new Promise<void>((resolve) => {
      const osc = ctx.createOscillator();
      osc.type = type;
      osc.frequency.value = freq;
      osc.connect(gain);
      osc.start();
      setTimeout(() => {
        osc.stop();
        resolve();
      }, durationMs);
    });

  try {
    if (scheme === 'minimal') {
      await playTone(440, 120, 'sine');
    } else if (scheme === 'retro') {
      await playTone(660, 120, 'square');
      await playTone(440, 120, 'square');
    } else {
      // default: short two-tone chime
      await playTone(523.25, 120, 'sine'); // C5
      await playTone(659.25, 150, 'sine'); // E5
    }
  } finally {
    // allow time for last tone to finish then close
    setTimeout(() => ctx.close(), 200);
  }
}